import React from "react";
import "./index.css";
import FormComponent from "../FormComponent";
import { siteContent } from "../content";

const PromocionLimitada = () => {
    return (
        <div className="section promocionLimitada">
            <div className="container-lg flex flexCol flexCenter">
                <h5 className="textCenter">{siteContent.promo.eyebrow}</h5>
                <h2 className="textCenter titleSec">
                    {siteContent.promo.title}
                </h2>
                <p className="textCenter pSec">
                    {siteContent.promo.description}
                </p>
                <div id="form">
                    <FormComponent />
                </div>
            </div>
        </div>
    );
};

export default PromocionLimitada;
